import React from "react";
import SimpleToggleButton from "../../../common/SimpleToggleButton/SimpleToggleButton";
import CfFormSelect from "./CfFormSelect";
import {
  FIELD_ROUNDED,
  INPUT_CLASS,
  LABEL_CLASS,
} from "../../../common/CertificateOnboarding/utils/styles";
import { coerceBoolean } from "../../../common/CertificateOnboarding/utils/variables";

function AttributeField({
  id,
  label,
  type = "text",
  value,
  onChange,
  options = [],
  placeholder,
  disabled = false,
  min,
  max,
  step,
  inputMode,
}) {
  const fieldId = id || `attr-${label}`;

  if (type === "toggle") {
    return (
      <div className="inline-flex items-center gap-2.5 py-1">
        <label htmlFor={fieldId} className={`${LABEL_CLASS} shrink-0`}>
          {label}
        </label>
        <SimpleToggleButton
          checked={coerceBoolean(value)}
          onChange={onChange}
          disabled={disabled}
          testId={fieldId}
          ariaLabel={label}
        />
      </div>
    );
  }

  if (type === "color") {
    const colorValue = value || "#000000";
    return (
      <div className="space-y-1.5">
        <label htmlFor={fieldId} className={LABEL_CLASS}>
          {label}
        </label>
        <div className="flex items-center gap-3">
          <input
            type="color"
            id={fieldId}
            value={colorValue}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className={`h-11 w-14 ${FIELD_ROUNDED} border border-cfSignInSignUpInputBorder cursor-pointer overflow-hidden`}
          />
          <input
            type="text"
            id={`${fieldId}-hex`}
            aria-label={`${label} hex value`}
            value={colorValue}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className={`${INPUT_CLASS} flex-1 font-mono text-xs`}
          />
        </div>
      </div>
    );
  }

  if (type === "select") {
    return (
      <CfFormSelect
        id={fieldId}
        label={label}
        value={value ?? ""}
        onChange={onChange}
        options={options}
        disabled={disabled}
      />
    );
  }

  if (type === "number") {
    return (
      <div className="space-y-1.5">
        <label htmlFor={fieldId} className={LABEL_CLASS}>
          {label}
        </label>
        <input
          type="number"
          id={fieldId}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          placeholder={placeholder}
          className={INPUT_CLASS}
        />
      </div>
    );
  }

  if (type === "textarea") {
    return (
      <div className="space-y-1.5">
        <label htmlFor={fieldId} className={LABEL_CLASS}>
          {label}
        </label>
        <textarea
          id={fieldId}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          rows={3}
          placeholder={placeholder}
          className={`${INPUT_CLASS} resize-y min-h-[4rem]`}
        />
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      <label htmlFor={fieldId} className={LABEL_CLASS}>
        {label}
      </label>
      <input
        type={type}
        id={fieldId}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        inputMode={inputMode}
        className={INPUT_CLASS}
      />
    </div>
  );
}

export default AttributeField;
